<template>
    <div class='layer-pop alert-pop'>
        <div class='view-content'>
            <div class='view-area'
                :style="{ backgroundImage: 'url(' + imgUrl + ')' }">
            </div>
            <div class='body-area'>
                <p class='body'>{{ title }}</p>
                <p class='body-medium'>
                    {{ body }}
                    <span class='info-expired'>
                        {{ expireDays }}일 남음
                    </span>
                </p>
                <p class='body-small'>{{ body2 }}</p>
            </div>
            <button @click='onClickBtnCancel' class='close-text'>확인</button>
            <p v-if='isTimeLimit' class='time-limit'>
                {{limitTime}}초 후 초기 화면으로 돌아갑니다.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'imageAlert3',
    props: {
        imgUrl: {
            type: String,
        },
        title: {
            type: String,
        },
        body: {
            type: String,
        },
        body2: {
            type: String,
        },
        isTimeLimit: {
            type: Boolean,
            default: false,
        },
        expireDays: {
            type: Number,
        },
    },
    mounted() {
        // 자동 팝업 닫힘
        if(this.isTimeLimit) {
            let timer = setInterval(() => {
                this.limitTime--;
                if(this.limitTime == 0) {
                    clearInterval(timer);
                    this.$emit('close-popup');
                }
            }, 1000);
        }
    },
    data() {
        return {
            limitTime: 5,
        };
    },
    methods: {
        onClickBtnCancel() {
            this.$emit('close-popup');
        },
    },
};
</script>

<style scoped>
    .body-area {
        .body-medium {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .body-small {
            margin-top: 8px !important;
        }
    }

    .time-limit {
        margin-top: 16px;
        font-family: Noto Sans CJK KR;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.6000000238418579px;
        text-align: center;
        color: #777777;
    }

    .info-expired {
        font-family: Noto Sans CJK KR;
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: -0.6000000238418579px;
        color: #3EC729;
        padding: 4px 12px 4px 12px;
        border-radius: 16px;
        border: 1px solid #3EC729;
        margin-left: 8px;

        &.not {
            color: #CCCCCC; 
            border-color: #CCCCCC;
        } 

        &.late {
            color: #F64444; 
            border-color: #F64444;
        } 
    }

</style>
